import React from 'react'

// Search/filter bar skeleton
const FeedHeaderSkeleton = () => (
    <div className="rounded-[10px] px-4 bg-white w-full flex flex-col items-center h-[68px] justify-center animate-pulse mb-4">
        <div className="flex items-center w-full">
            <div className="h-[41px] w-[270px] bg-lightBG rounded-full mr-4"></div>
            <div className="h-[41px] w-[120px] bg-lightBG rounded-full"></div>
        </div>
    </div>
)
// Single feed item skeleton
export const FeedItemSkeleton = () => (
    <div className="flex flex-col items-center w-full">
        <div className="bg-[#F8F8FB] h-6 w-[200px] mt-[20px]"></div>
        <div className="feed-background p-5 w-full flex flex-row items-stretch gap-[15px] rounded-xl mt-[15px] border border-white overflow-hidden animate-pulse mb-4 ">
            {/* 273px and a 10px radius to match the real image slot in
                SingleFeed (ImageWithPlaceholder), which replaces this on load. */}
            <div className="w-full max-w-[273px] shrink-0 self-stretch bg-white rounded-[10px]"></div>
            <div className="flex flex-col flex-1 min-w-0">
                <div className="h-5 bg-white rounded w-[60%] mb-2"></div>
                <div className="h-4 bg-white rounded w-[80%] mb-2"></div>
                <div className="h-4 bg-white rounded w-[90%] mb-2"></div>
                <div className="h-4 bg-white rounded w-[70%] mb-4"></div>
                <div className="flex flex-row w-full gap-4 mt-auto">
                    <div className="h-10 w-full bg-white rounded-full"></div>
                </div>
            </div>
        </div>
    </div>
)

const FeedSkeleton = () => {
    return (
        <div className="relative flex flex-col h-full">
            <FeedHeaderSkeleton />
            <div className="p-2 w-full rounded-[10px] bg-white h-full grow flex flex-col">
                <div className="w-full px-6 mb-5 gray-small-scroll overflow-y-scroll h-0 flex-auto" id="scroll-inf-feed">
                    {[...Array(4)].map((_, idx) => (
                        <FeedItemSkeleton key={idx} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default FeedSkeleton
